import * as types from './mutation-types'

export default {
  [types.SET_CURRENT_TEMPLATE](state, data) {
    state.currentTemplate = data
  },
}
